import React, { Component } from 'react'
import { shape, string, func, bool } from 'prop-types'
import { setPerimeterXWindow, unsetPerimeterXWindow } from 'services/utils/storage'
import { loadScript } from 'services/utils/common'
import { PERIMETERX_MSG } from 'services/utils/constants/validations'

class RecaptchaBlock extends Component {
  constructor(props) {
    super(props)
    const {
      login, loginActions, formData, ui,
    } = props
    const { isThirdParty, clientId, redirectUri } = ui
    const {
      username, password, countryCode, isPhoneNumber,
    } = formData
    let { rememberMe } = formData
    rememberMe = rememberMe ? 'Y' : 'N'
    const method = isThirdParty ? 'authorization' : 'authentication'
    const params = {
      username,
      password,
      countryCode,
      isPhoneNumber,
      rememberMe,
      redirectUri,
      method,
      ...(isThirdParty ? { clientId } : { }),
    }

    setPerimeterXWindow(login)
    // eslint-disable-next-line no-underscore-dangle
    window._pxOnCaptchaSuccess = (isValid) => {
      /* istanbul ignore else */
      if (isValid) {
        loginActions.loginUser(params)
      }
    }
  }
  componentDidMount() {
    const { login: { blockScript } } = this.props
    loadScript(blockScript)
  }

  componentWillUnmount() {
    unsetPerimeterXWindow()
  }

  render() {
    return (
      <div data-testid="recaptcha-container" id="recaptcha-container">
        <h4>
          {PERIMETERX_MSG}
        </h4>
        <div id="px-captcha" />
      </div>
    )
  }
}
RecaptchaBlock.propTypes = {
  loginActions: shape({
    loginUser: func,
  }).isRequired,
  login: shape({}).isRequired,
  ui: shape({
    isThirdParty: bool,
    clientId: string,
    redirectUri: string,
  }).isRequired,
  formData: shape({
    email: string,
    password: string,
  }).isRequired,
}

export default RecaptchaBlock
